import { IVisitationPending } from '../models/visitation';
import { IApiService, IPaginatedResponse } from '../services/api_service';

export const visitationPending = (siteApi: IApiService) => ({
  index: (params?): Promise<IPaginatedResponse<IVisitationPending>> => {
    return siteApi.get('/visitation-pending', { params });
  },
  put: (id, note, timeLimit) => {
    return siteApi.put('/visitation-pending', {
      id,
      note,
      timeLimit
    });
  },
  approve: (id, note, timeLimit) => {
    return siteApi.put('/visitation-pending/approve', {
      id,
      note,
      timeLimit
    });
  },
  reject: (id, note) => {
    return siteApi.put('/visitation-pending/reject', {
      id,
      note
    });
  }
});
